/**
 * Centralized Candidate / Profile Status Definitions & Labels
 * Ensures consistency across Dropdown, Lists, Badges, and Kanban board.
 */

export const STATUS_DEFINITIONS = [
  { id: 1, value: "Vendor_Submission", label: "Vendor Submission", baseProbability: 10 },
  { id: 2, value: "Internal_Evaluation", label: "Internal Evaluation", baseProbability: 20 },
  { id: 3, value: "Internal_Screening", label: "Internal Screening", baseProbability: 15 },
  { id: 4, value: "Internal_Feedback", label: "Internal Feedback", baseProbability: 25 },
  { id: 5, value: "Submitted_To_Client", label: "Submitted to Client", baseProbability: 30 },
  { id: 6, value: "Client_Evaluation", label: "Client Evaluation", baseProbability: 40 },
  { id: 14, value: "Awaiting_for_slots", label: "Awaiting for slots", baseProbability: 50 },
  { id: 7, value: "L1_Round", label: "L1 Round", baseProbability: 60 },
  { id: 8, value: "L2_Round", label: "L2 Round", baseProbability: 70 },
  { id: 9, value: "L3_Round", label: "L3 Round", baseProbability: 80 },
  { id: 18, value: "Selected_Onboarding", label: "Pending Offer", baseProbability: 90 },
  { id: 15, value: "Onboarding_In_Process", label: "Onboarding in process", baseProbability: 95 },
  { id: 10, value: "Onboarded", label: "Onboarded", baseProbability: 100 },
  { id: 11, value: "Rejected", label: "Rejected", color: "#f44336", baseProbability: 0 },
  { id: 12, value: "Interview_Cancelled", label: "Interview Cancelled", color: "#ff9800", baseProbability: 0 },
  { id: 13, value: "Position_on_hold", label: "Position on Hold", color: "#2196f3", baseProbability: 0 },
  { id: 16, value: "No_Updates", label: "No Updates", baseProbability: 0 },
  { id: 17, value: "Close-No_Client_Response", label: "Close-No Client Response", color: "#f44336", baseProbability: 0 },
];

export const STATUS_LABEL_MAP = STATUS_DEFINITIONS.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

/**
 * Returns formatted label for a detailed_status string.
 * Uses exact mapping if available, falls back to replacing underscores with spaces.
 */
export const parseStatusLabel = (status) => {
  if (!status) return "";
  
  // 1. Exact match
  if (STATUS_LABEL_MAP[status]) return STATUS_LABEL_MAP[status];

  // 2. Case-insensitive match
  const upperStatus = status.toUpperCase();
  const matchedKey = Object.keys(STATUS_LABEL_MAP).find(k => k.toUpperCase() === upperStatus);
  if (matchedKey) return STATUS_LABEL_MAP[matchedKey];

  // 3. Fallback: clean up dashes/underscores and apply Title Case
  return status
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
